import React, { useState } from 'react';
import { Footer } from "./components/layout/Footer";
import { Navbar } from "./components/layout/Navbar";

import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { GraduationPage } from "./pages/GraduationPage";

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Pages kept mounted after their first visit and only hidden when you leave them,
// so their iframes (YouTube, Spotify) and state don't reload on every page change.
const KEEP_ALIVE_PAGES = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
];

const isKeepAlive = (path) => KEEP_ALIVE_PAGES.some((page) => page.path === path);

const Pages = () => {
  // "/about/" and "/about" are the same page
  const path = useLocation().pathname.replace(/\/+$/, "") || "/";

  // Pages are mounted lazily: About's iframes don't load until you open About
  const [visited, setVisited] = useState(() => new Set([path]));
  if (isKeepAlive(path) && !visited.has(path)) {
    setVisited(new Set(visited).add(path));
  }

  return (
    <>
      {KEEP_ALIVE_PAGES
        .filter((page) => visited.has(page.path))
        .map((page) => (
          <div key={page.path} hidden={page.path !== path}>
            {page.element}
          </div>
        ))}

      <Routes>
        <Route path="/graduation" element={<GraduationPage />} />
        {/* Keep-alive pages are rendered above: match everything else to nothing */}
        <Route path="*" element={null} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="bg-stone-200 dark:bg-stone-700">

      <Router>
        <Navbar />
        <Pages />
      </Router>

      <Footer />
    </div>
  );
}

export default App;
